module.exports = __webpack_public_path__ + "img/logo_kjcs2.c3e963b4.png";